function initializeRecipesSliders() {
  const selectors = window.__codefixrRecipesSliders || [];
  selectors.forEach((selector) => {
    const element = document.querySelector(selector);
    if (!element) return;
    if (element.__splideInitialized) return;

    try {
      const SplideGlobal = window.Splide;
      if (!SplideGlobal) return;
      
      // Count total slides
      const totalSlides = element.querySelectorAll('.splide__slide').length;
      
      const splide = new SplideGlobal(element, {
        type: 'loop',
        perPage: 4,
        gap: '20px',
        pagination: false,
        arrows: totalSlides > 4, // Show arrows only if more than 4 slides
        loop: true,
        breakpoints: {
          1536: { 
            gap: '16px',
            arrows: totalSlides > 4
          },
          1280: { 
            perPage: 3, 
            arrows: totalSlides > 3,
            gap: '16px'
          },
          1024: { 
            perPage: 2, 
            arrows: totalSlides > 2,
            gap: '16px'
          },
          640: { 
            perPage: 1, 
            arrows: totalSlides > 1,
            gap: '12px'
          },
        },
      }).mount();
      
      // Customize the arrow content with your SVG
      addRecipesSplideArrows(splide);
      
      element.__splideInitialized = true;
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error('Failed to init Splide for', selector, e);
    }
  });
}

function addRecipesSplideArrows(splideInstance) {
  const prevArrow = splideInstance.root.querySelector('.splide__arrow--prev');
  const nextArrow = splideInstance.root.querySelector('.splide__arrow--next');
  
  if (prevArrow) {
    prevArrow.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="42" height="41" viewBox="0 0 42 41" fill="none"> <g clip-path="url(#clip0_17009_14268)"> <circle cx="20.9995" cy="20.4545" r="20.4545" fill="#0B4970"/> <path d="M21.2695 27.0506L27.6091 20.7345C28.0042 20.3316 28.0135 19.6569 27.6091 19.2539L21.2695 12.9378C20.8839 12.5536 20.2443 12.5349 19.8398 12.891C19.379 13.2846 19.3601 13.9967 19.7834 14.4278L24.3358 18.9634C24.3358 18.9634 14.2057 18.9634 14.1869 18.9634C12.8607 18.9634 12.8325 21.0625 14.1869 21.0625H24.3358L19.7834 25.5981C19.379 26.001 19.379 26.6758 19.7834 27.0787C20.1973 27.463 20.8557 27.463 21.2695 27.0506Z" fill="white" stroke="white" stroke-width="0.490909"/> </g> <defs> <clipPath id="clip0_17009_14268"> <rect x="0.544922" width="40.9091" height="40.9091" rx="20.4545" fill="white"/> </clipPath> </defs> </svg>`;
  }
  
  if (nextArrow) {
    nextArrow.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="42" height="41" viewBox="0 0 42 41" fill="none"> <g clip-path="url(#clip0_17009_14268)"> <circle cx="20.9995" cy="20.4545" r="20.4545" fill="#0B4970"/> <path d="M21.2695 27.0506L27.6091 20.7345C28.0042 20.3316 28.0135 19.6569 27.6091 19.2539L21.2695 12.9378C20.8839 12.5536 20.2443 12.5349 19.8398 12.891C19.379 13.2846 19.3601 13.9967 19.7834 14.4278L24.3358 18.9634C24.3358 18.9634 14.2057 18.9634 14.1869 18.9634C12.8607 18.9634 12.8325 21.0625 14.1869 21.0625H24.3358L19.7834 25.5981C19.379 26.001 19.379 26.6758 19.7834 27.0787C20.1973 27.463 20.8557 27.463 21.2695 27.0506Z" fill="white" stroke="white" stroke-width="0.490909"/> </g> <defs> <clipPath id="clip0_17009_14268"> <rect x="0.544922" width="40.9091" height="40.9091" rx="20.4545" fill="white"/> </clipPath> </defs> </svg>`;
  }
}

document.addEventListener('DOMContentLoaded', initializeRecipesSliders);